import { transformLocaleToLanguageCode } from "./helper"

export function retrieveLanguageCode() {
  return transformLocaleToLanguageCode(navigator.language)
}
